import { memo, useCallback } from 'react';

import { PublicCreatorSelect } from '~/components/Filters/CreatorFilter/components/PublicCreatorSelect';
import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { StringArrayFilterCard } from '~/components/Filters/StringArrayFilterCard';
import { type BaseStringSelectProps } from '~/components/StringSelect';

export type PublicCreatorFilterCardProps = {
  boardId: string | undefined;
} & BaseFilterCardProps;

export const PublicCreatorFilterCard = memo(({ boardId, ...props }: PublicCreatorFilterCardProps) => {
  const renderStringSelect = useCallback(
    (props: BaseStringSelectProps) => <PublicCreatorSelect boardId={boardId} {...props} />,
    [boardId],
  );

  return (
    <StringArrayFilterCard filterCardType="creator" filter="creators" StringSelect={renderStringSelect} {...props} />
  );
});

PublicCreatorFilterCard.displayName = 'PublicCreatorFilterCard';
